export default "__VITE_ASSET___xM1fwaD__"